// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"41":"f9a336fa","158":"c69f2701","299":"1e990d85","328":"4359ecaa","446":"3b58fb3f","450":"240b29e6","517":"97b08881","685":"382f900b","722":"2f59d4f3","884":"720632f5","965":"616128fc"}[chunkId] + ".js";
};